import React, { FC, useMemo } from 'react';
import { useTheme } from '@mui/material';
import Widget from 'src/components/Widget';
import { ApiServiceImpl } from 'src/api/services';
import ExpensesGraphContent from './Content';
import LoadingSkeleton from 'src/components/LoadingSkeleton';
import { TimeSpan } from 'src/viewsTypes';
import { DashboardDataExpenses } from 'src/api/services/types';

const title = 'סיכום הוצאות';
type DataType = DashboardDataExpenses['dataPoints'];

const ExpensesGraph: FC = () => {
  const timeSpan: TimeSpan = useMemo(() => ({ timeUnit: 'M', count: 6 }), []);
  const { spacing } = useTheme();
  const size = useMemo(
    () => ({ width: spacing(52.5), height: spacing(40) }),
    [spacing],
  );

  return (
    <Widget<DataType>
      title={title}
      size={size}
      filters={{ timeSpan }}
      service={ApiServiceImpl.getExpensesSummary}
      Content={ExpensesGraphContent}
      LoadingSkeleton={<LoadingSkeleton height="60%" />}
    />
  );
};

export default ExpensesGraph;
